import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useGeneralProductionChartsDataContext } from './hooks/useGeneralProductionChartsDataContext';

export const ServicesByAge = () => {
    const { chartData } = useGeneralProductionChartsDataContext();


    return (
        <SimpleBars
            title={'Atendimentos por Faixa Etária'}
            horizontal={true}
            subtitles={chartData?.servicesByAge?.map((item) => item.description)}
            values={chartData?.servicesByAge?.map((item) => item.total  ||  0)}
        />
    );
};
